import AuthContext from "context/AuthContext";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {useState, useContext, useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useParams} from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SwalAlertClass} from "core/swalClass";
import NavBreadcrum from "components/NavBreadcrum";
import TabDownload from "./tabs/TabDownload";
import TabSelectFile from "./tabs/TabSelectFile";
import TabVerifyData from "./tabs/TabVerifyData";
import TabConfirmImport from "./tabs/TabConfirmImport";
import TabResult from "./tabs/TabResult";
import PluginModel from "site-apps/plugins/PluginModel";
import axiApi from "ApiCaller";
import navs from "../../navs";

const stepTabsStatus = {
    //Status disabled tabs
    download: false,
    select: false,
    validation: true,
    confirmation: true,
    result: true
}

const dataVerified = {
    news: {devices: 0},
    updated: {devices: 0},
    counter: {devices: 0},
    errors: 0,
    warnings: 0,
}

function PluginImport() {
    const {user} = useContext(AuthContext);
    const [t] = useTranslation("routes")
    const [tF] = useTranslation("forms")
    document.title = t("labels.import")
    const bread = [
        {name: t("labels.administration"), url: "/administration", current: false},
        {name: document.title, current: true}
    ];
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    // ---
    const {token} = useParams();
    const [keyTab, setKeyTab] = useState('download');
    const [statusTabs, setStatusTabs] = useState(stepTabsStatus);
    const warnings = useRef([])
    const [warningsShow, setWarningsShow] = useState([]);
    const [dataVerify, setDataVerify] = useState(dataVerified)
    const roomID = useRef("");
    const [plugin, setPlugin] = useState({...PluginModel})


    const handleBackSelectFile = () => {
        let tabs = {...stepTabsStatus};
        tabs.validation = true;
        tabs.confirmation = true;
        tabs.result = true;
        setStatusTabs(tabs);
        setKeyTab("select");
    }

    useEffect(() => {
        axiApi.get(`/api/plugins/inventory/identify/${token}/`)
            .then((r) => {
                if (r.data.status) {
                    setPlugin({...r.data.item});
                    setDataVerify(dataVerified);
                    setStatusTabs(stepTabsStatus);
                } else {
                    Alert.warning("No se ha recuperado.", "No se puede continuar avisar al administrador.");
                }
            })
            .catch((err) => {
                console.error(err);
            });

    }, []);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread}/>
            <div className="col-12 preview-canvas offcanvas-header mt-1">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="file-import"/>
                </div>

                <div className="preview-title ps-4 d-flex justify-content-between w-100 align-items-center">
                    <h5>{tF("inventory.title")}</h5>
                    <div>
                        <span className="me-3 h4">{plugin.name}</span>
                        {
                            plugin.slug ?
                                <img src={"/media/plugins/" + plugin.slug + "/image.png"} alt="logo" height="50"/>
                                : <></>
                        }
                    </div>
                </div>
            </div>
            {
                plugin.name ?
                    <Tabs
                        activeKey={keyTab}
                        id="plugins-import"
                        onSelect={(k) => setKeyTab(k)}
                        className="mb-3"
                        justify
                    >
                        <Tab eventKey="download" title="Descargar">
                            <TabDownload user={user} setKeyTab={setKeyTab} token={token}/>
                        </Tab>
                        <Tab eventKey="select" title={tF("labels.select-file")}>
                            <TabSelectFile user={user}/>
                        </Tab>
                        <Tab eventKey="validation" title={tF("labels.validation-data")} disabled={statusTabs.validation}>
                            <TabVerifyData
                                stepTabsStatus={stepTabsStatus}
                                setStatusTabs={setStatusTabs}
                                setKeyTab={setKeyTab}
                                setDataVerify={setDataVerify}
                                roomID={roomID}
                                token={token}
                                setWarningsShow={setWarningsShow}
                                warningsShow={warningsShow}
                                warnings={warnings}
                                handleBackSelectFile={handleBackSelectFile}
                            />
                        </Tab>
                        <Tab eventKey="confirmation" title={tF("labels.confirmation")}
                             disabled={statusTabs.confirmation}>
                            <TabConfirmImport
                                statusTabs={statusTabs}
                                warnings={warningsShow}
                                dataVerify={dataVerify}
                                handleBackSelectFile={handleBackSelectFile}
                                setStatusTabs={setStatusTabs}
                                setKeyTab={setKeyTab}
                                roomID={roomID}
                            />

                        </Tab>
                        <Tab eventKey="result" title={tF("labels.result")} disabled={statusTabs.result}>
                            <TabResult
                                warns={warnings}
                                token={token}
                            />
                        </Tab>
                    </Tabs>
                    : <></>

            }

        </>
    );
}

export default PluginImport;